import moment from 'moment-timezone';

export class TimeZone {
    // For testing. Make sure to clean this up when you're done or it will
    // pollute ALL other tests!
    static BROWSER_TIMEZONE_OVERRIDE: string = null;

    private readonly _tzString: string;

    constructor(tzString: string) {
        if (!tzString) {
            throw new Error('time zone string is required');
        }
        this._tzString = tzString;
    }

    getOffsetAtTime(time: number): number {
        return moment.tz.zone(this._tzString).utcOffset(time);
    }

    get string(): string {
        return this._tzString;
    }

    static get UTC() {
        return new TimeZone('utc');
    }

    static get LOCAL() {
        return new TimeZone(
            this.BROWSER_TIMEZONE_OVERRIDE ? this.BROWSER_TIMEZONE_OVERRIDE : moment.tz.guess(),
        );
    }
}
